module.exports = __webpack_public_path__ + "media/assets/stores/apple-4bd3fa45ca8a8b7fc7dcaeabe48f51df.png";